import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Button, Modal, Form, message, DatePicker, Col, Row } from "antd";
import { useEffect } from "react";
import { handleMoveToAutoExecutor } from "../../../api/autorequests";

export default function MoveToExecutor({
  isVisible,
  setVisible,
  selected,
}: any) {
  const { _id } = selected;
  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  const { mutate, isPending } = useMutation({
    mutationFn: handleMoveToAutoExecutor,
    onSuccess: () => {
      message.success("Moved to Executor Successfully");
      form.resetFields();
      queryClient.invalidateQueries({ queryKey: ["requests"] });
      queryClient.invalidateQueries({ queryKey: ["autorequests"] });
      queryClient.invalidateQueries({ queryKey: ["unitRequests"] });
    },
    onError: () => {
      message.error("Something went wrong");
    },
  });

  const onSubmit = async () => {
    const values = await form.getFieldsValue();
    const data = { ...values };
    await mutate({ _id, data });
    setVisible(false);
  };

  const clearForm = async () => {
    form.resetFields();
  };

  useEffect(() => {
    form.resetFields();
  }, [selected, form]);

  return (
    <Modal
      open={isVisible}
      title="Move to Executor"
      onCancel={() => setVisible(false)}
      footer={[
        <Button danger key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="moveToExecutor"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isPending}
          danger
        >
          Move to Executor
        </Button>,
      ]}
    >
      <Form
        id="moveToExecutor"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="dateExecuted"
              label="Date Executed"
              rules={[
                {
                  required: false,
                  message: "Please select date",
                },
              ]}
            >
              <DatePicker
                format="DD/MM/YYYY"
                style={{ width: "100%" }}
                placeholder="Date Executed"
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
